import { Outlet } from 'react-router-dom';

const StatutoryBodies = () => {
    return (
        <>
            <Outlet />
        </>
    )
}

export default StatutoryBodies
